
import React, { useState } from 'react';
import Footer from './Footer';

function ContactM() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [subject, setSubject] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
    
        const emailSubject = `Subject: ${subject}`
        const emailBody = `Name: ${name}\nEmail: ${email}\nMessage: ${message}`;
    
        const mailtoLink = `mailto:eurezolv@gmail.com?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
    
        window.location.href = mailtoLink;
    };

    return (
        <div>
        <div className='contact-main'>
            
            <div className="contact1">

            
            <h1>Contactează-ne</h1>
            <form onSubmit={handleSubmit}>
                <label htmlFor="name">Nume:</label>
                <input
                    type="text"
                    id="namec"
                    placeholder='Introdu-ti numele'
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />

                <label htmlFor="email">Email:</label>
                <input
                    type="email"
                    id="emailc"
                    placeholder='Introdu-ti adresa de email'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />

                <label htmlFor="Subiect">Subiect:</label>
                <input
                    type="text"
                    id="subjectc"
                    
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                />



                <label htmlFor="message">Message:</label>
                <input
                    id="messagec"
                    value={message}
                    placeholder='Trimite-ne un mesaj'
                    onChange={(e) => setMessage(e.target.value)}
                ></input>

                <button type="submit">Trimite</button>
            </form>
            </div>
            <div className="map">
            <div className="map-container">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2732.645971708668!2d23.54760747659806!3d46.771874345245415!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47490ef6cd497be9%3A0x6ba5cbf7bcdac133!2sStrada%20Uliului%2024%2C%20Cluj-Napoca%20400535!5e0!3m2!1sro!2sro!4v1707991460547!5m2!1sro!2sro" width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
</div>
                </div>
                <div className='datecontact'>
                <div className='adresa'>
                <h1>Adresa:</h1>
                <h5>CLUJ-NAPOCA, Str. ULIULUI, Nr. 24, Jud. CLUJ, Romania</h5>
                </div>
                <div className='telefon'>
                <h1>Telefon:</h1>
                <h5>0724 869 426</h5>
                </div>
                <div className='email'>
                <h1>Email:</h1>
                <h5>eurezolv@gmail.com</h5>
                </div>
            
            </div>
            

        
        </div>
        <div className="footer">
              <Footer />
              </div>
        </div>
        
    );
}

export default ContactM;

